import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    assignAddOnGroupToProduct,
    removeAddOnGroupFromProduct,
    type AssignAddOnGroupPayload,
} from '../services/productAddonGroups';
import { productAddOnGroupKeys } from './useProductAddOnGroupsQuery';
import { productAddOnKeys } from './useProductAddOnsQuery';

export function useProductAddOnGroupMutations(productId: string) {
    const qc = useQueryClient();

    const assignMutation = useMutation({
        mutationFn: (payload: AssignAddOnGroupPayload) =>
            assignAddOnGroupToProduct(productId, payload),
        onSuccess: () => {
            // Assigning a group bulk-creates product_addons rows, so invalidate both caches.
            qc.invalidateQueries({ queryKey: productAddOnGroupKeys.list(productId) });
            qc.invalidateQueries({ queryKey: productAddOnKeys.list(productId) });
        },
    });

    const removeMutation = useMutation({
        mutationFn: (addonGroupId: string) =>
            removeAddOnGroupFromProduct(productId, addonGroupId),
        onSuccess: () => {
            // Removing a group does NOT touch product_addons, so only invalidate groups cache.
            qc.invalidateQueries({ queryKey: productAddOnGroupKeys.list(productId) });
        },
    });

    return { assignMutation, removeMutation };
}
